export enum SocialsLinks {
	Discord = 'https://discord.heni.com',
	Instagram = 'https://www.instagram.com/heni',
	Twitter = 'https://twitter.com/heni',
	Tiktok = 'https://www.tiktok.com/@heni',
	YouTube = 'https://www.youtube.com/@HENITalks',
	Telegram = 'https://t.me/HENIArtNews'
}

// HENI News runs its own social accounts, separate from the group-wide handles
// in SocialsLinks. Used by the newsletter footer.
export enum NewsSocialsLinks {
	Instagram = 'https://www.instagram.com/heninews/',
	Facebook = 'https://www.facebook.com/HENINews/',
	Tiktok = 'https://www.tiktok.com/@heni.news'
}
